<app-loader></app-loader>
<app-confirm-dialog></app-confirm-dialog>

<app-header></app-header>
<router-outlet></router-outlet>
<!--<router-outlet name="appoint"></router-outlet>-->
